var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-vertical',[_c('template',{slot:"bread-actions"},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],attrs:{"name":"bread-actions"}})],1),_c('div',[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }